import * as angular from 'angular';
import { CallsService } from './CallsService';
export const callsModule = angular
    .module('app.calls', [])
    .service('CallsService', CallsService)
    .name;
